<template>
  <div>
    <div class="legal" v-if="width > 768">
      <p id="title-forms" class="text-introduction-legal">
        ¡Hola!
        La información que requerimos para esta parte de tu proceso de selección está segura. Por favor, lee nuestra Política de Tratamiento de Datos y haz clic en “Aceptar”    
      </p>    
      <iframe src="/public_politicadeprivacidad_globalwork.pdf" width="720" height="600"></iframe>
      <div class="row row-accept">
        <div class="col-sm-12 text-center">
          <b-button class="button-save button-form-steps save-academic" @click.prevent="save">Acepto</b-button>
        </div>
      </div>      
    </div>    
    <div class="" v-else>
      <iframe src="/public_politicadeprivacidad_globalwork.pdf" width="360" height="600"></iframe>
      <div class="row row-accept">
        <div class="col-sm-12 text-center">
          <b-button class="button-save button-form-steps save-academic" @click.prevent="save">Acepto</b-button>
        </div>
      </div>      
    </div>        
  </div>
</template>

<script>
import axios from "axios";
import { eventBus } from './../../../application'
export default {
  name: "LegalForm",
  props: ['project'],    
  data() {
    return {
      width: null,
    }
  },
  methods: {
    defaultAxios(){
			var token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
			axios.defaults.headers['x-csrf-token'] = token
			axios.defaults.headers.common['Accept'] = 'application/json';
			axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    },        
    save() {
      this.defaultAxios()
      axios.put(`/update_information_project`, { project: { id: this.project.id, accept_terms: true } })
      eventBus.$emit('changeLegal')
    }
  },
  created () {

  },

  mounted () {
    this.width = screen.width
  },
}
</script>
<style scoped>
  .text-introduction-legal{
    text-align: center;
    margin-bottom: 1rem;
  }
</style>